import React from 'react';

import './Discover.css'

import discoverItemIcon1 from '../../assets/images/Home/discoverItemIcon1.svg'
import discoverItemIcon2 from '../../assets/images/Home/discoverItemIcon2.svg'
import discoverItemIcon3 from '../../assets/images/Home/discoverItemIcon3.svg'
import discoverItemIcon4 from '../../assets/images/Home/discoverItemIcon4.svg'
import discoverItemIcon5 from '../../assets/images/Home/discoverItemIcon5.svg'
import discoverItemIcon6 from '../../assets/images/Home/discoverItemIcon6.svg'

const Discover = () => {

    const ourServicesArr = [
            {
                id: 1,
                title: 'Ready-made companies for sale',
                descr: 'Companies with a bank account around the world',
                img: discoverItemIcon1
            },
            {
                id: 2,
                title: 'Banks for sale',
                descr: 'Established Banks for sale',
                img: discoverItemIcon2
            },
            {
                id: 3,
                title: 'Ready-made licenses for sale',
                descr: 'Forex, cryptocurrencies, gambling,EMI, PSP, SVF, MSO, DLT',
                img: discoverItemIcon3
            },
            {
                id: 4,
                title: 'Licensing',
                descr: 'Forex licenses, cryptocurrencies, gambling, EMI, PSP, SVF, MSO, DLT',
                img: discoverItemIcon4
            },
            {
                id: 5,
                title: 'Offshore company registration',
                descr: 'Expert advice on the acquisition of an offshore company',
                img: discoverItemIcon5
            },
            {
                id: 6,
                title: 'Open a bank account',
                descr: 'Open bank accounts in more than 120 banks around the world',
                img: discoverItemIcon6
            },
    
        ]

    return (
        <div className="discover-our-services">
                <h2 className="discover-our-title">
                    Discover Our Service
                </h2>
                <div className="discover-our-sub-title-wrapper">
                    <p className="discover-our-sub-title">
                        The international company Offshore Advisory International provides professional services in the field of international consulting, auditing services, legal and tax services.
                    </p>
                </div>
                <div className="discover-keys-wrapper">
                    {ourServicesArr.map((item) => (
                        <div className="discover-key-item" key={item.id}>
                            <div className="discover-item-header-wrapper">
                                <h3 className="discover-item-title">
                                    {item.title}
                                </h3>
                                <div className="discover-item-img-wrapper">
                                    <img src={item.img} />
                                </div>
                            </div>
                            <p className="discover-item-descr">
                                {item.descr}
                            </p>
                        </div>
                    ))}
                    
                </div>
            </div>
    );
};

export default Discover;